<template>
    <rkm-area
        class="mt-4"
        title="Atendimento Médico"
        type="fieldset"
    >
        <template slot="trailing">
            <rkm-button
                @click="internalVisible = !internalVisible"
                color="primary"
                small
            >
                <rkm-icon :icon="internalVisible ? 'angle-double-up' : 'angle-double-down'" />
            </rkm-button>
        </template>

        <rkm-collapse :visible="internalVisible">
            <Form :data="data" :readonly="readonly"/>
        </rkm-collapse>
    </rkm-area>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    created() {
        this.internalVisible = this.visible
    },
    data: () => ({
        internalVisible: false,
    }),
    props: {
        data: { type: Object, required: true },
        readonly: { type: Boolean },
        visible: { type: Boolean, default: true },
    },
}
</script>